import ActivityIndicator from './ActivityIndicator';

export default ActivityIndicator;
